<div class="app" >
</div>

<router-outlet></router-outlet> 